"use client";

import { useEffect } from "react";
import { initSentry, isSentryEnabled, syncSentryScope } from "@/lib/sentry";
import { useStore } from "@/store";

/**
 * Boots Sentry once on the client and keeps its user/session scope aligned
 * with the auth/session store.
 */
export default function SentryBootstrap() {
  const authStatus = useStore.use.authStatus();
  const user = useStore.use.user();
  const sessionId = useStore.use.sessionId();
  const sessionStatus = useStore.use.status();
  const sessionActive = useStore.use.sessionActive();

  useEffect(() => {
    initSentry();
  }, []);

  useEffect(() => {
    if (!isSentryEnabled()) {
      return;
    }

    syncSentryScope({
      authStatus,
      userId: user?.user_id ?? null,
      userCode: user?.user_code ?? null,
      provider: user?.provider ?? null,
      isAdmin: user?.is_admin === true,
      sessionId,
      sessionStatus,
      sessionActive,
    });
  }, [authStatus, sessionActive, sessionId, sessionStatus, user]);

  return null;
}
